import { render, staticRenderFns } from "./CapitalGainsTaxDialog.vue?vue&type=template&id=7ccc7f56&scoped=true"
import script from "./CapitalGainsTaxDialog.vue?vue&type=script&lang=js"
export * from "./CapitalGainsTaxDialog.vue?vue&type=script&lang=js"
import style0 from "./CapitalGainsTaxDialog.vue?vue&type=style&index=0&id=7ccc7f56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccc7f56",
  null
  
)

export default component.exports